import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
import noZoom from "./assets/js/noZoom";
noZoom();
export default {
  provide() {
    return {
      reload: this.reload,
      setPopHowWorksShow: this.setPopHowWorksShow
    };
  },
  computed: {
    ...walletVuex.mapState(["isMobile", "mPath", "address", "netId"]),
    ...walletVuex.mapGetters(["isWeb3Wallet"]),
    route() {
      return this.$route.path;
    }
  },
  data() {
    return {
      isRouterAlive: true,
      popHowWorksShow: false
    };
  },
  watch: {
    "$route.path": {
      async handler(newPath, oldPath) {
        this.setMpath(false);
        if (newPath === "/") {
          this.WebApp.BackButton.isVisible && this.WebApp.BackButton.hide();
        } else {
          this.WebApp.BackButton.show();
        }
        this.clearPopFunc();
        this.$nextTick(this.setMpath(newPath != oldPath));
      },
      deep: true
    },
    isWeb3Wallet: {
      async handler(bool) {
        if (bool) {
          const res = await this.getLoginInfo([null, "refCode"]);
          if (!res) return;
        }
        this.setIsWallet(bool);
      },
      deep: true,
      immediate: true
    },
    address: {
      handler(newAddr, oldAddr) {
        console.log("newAddr, oldAddr", newAddr, oldAddr);
        if (newAddr != oldAddr && oldAddr) {
          this.reload();
        }
      },
      immediate: true
    },
    netId: {
      handler(newNetId, oldNetId) {
        console.log("newNetId, oldNetId", oldNetId);
        if (newNetId != oldNetId && oldNetId) {
          this.reload();
        }
      },
      immediate: true
    }
  },
  methods: {
    ...walletVuex.mapMutations(["setMpath", "setIsWallet"]),
    ...userVuex.mapActions(["getChainInfo", "getLoginInfo"]),
    clearIntervalAndTimeoutFn() {
      clearInterval(_v.tokenBalanceTimer);
      clearTimeout(_v.kLinePullTimer);
      for (let i = 1; i < 30000; i++) {
        clearInterval(i);
        clearTimeout(i);
      }
    },
    async reload() {
      this.clearIntervalAndTimeoutFn();
      await this.web3Wallet.web3WindQueryFn();
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    setPopHowWorksShow(bool) {
      this.popHowWorksShow = bool;
    }
  },
  async created() {
    await this.getChainInfo();
    await this.web3Wallet.connectJsonRpc();
    await this.web3Wallet.initWeb3Modal();
    // const walletConnected = localStorage.getItem("v.wallet.connected");
    // if (!walletConnected) {
    //   await this.web3Wallet.connectJsonRpc();
    // }
  },

  mounted() {
    console.log(this.web3Wallet);
    this.WebApp.BackButton.onClick(() => {
      this.$router.go(-1);
    });
  }
};